import { render, staticRenderFns } from "./fee_std.vue?vue&type=template&id=5624c828&scoped=true&"
import script from "./fee_std.vue?vue&type=script&lang=js&"
export * from "./fee_std.vue?vue&type=script&lang=js&"
import style0 from "./fee_std.vue?vue&type=style&index=0&id=5624c828&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5624c828",
  null
  
)

export default component.exports